import { defineMessages } from 'react-intl';
const Tabs = {
    adresy: 'adresy',
    parcely: 'parcely',
    coords: 'coords',
};
export const tabMessages = defineMessages({
    adresy: {
        id: 'search.adresy',
        defaultMessage: 'Adresy',
    },
    parcely: {
        id: 'search.parcely',
        defaultMessage: 'Parcely',
    },
    coords: {
        id: 'search.coords',
        defaultMessage: 'Souřadnice',
    },
});
export const itemMessages = defineMessages({
    adresy: {
        id: 'search.adresy.item.content.html',
        defaultMessage: '<ITEM><LABEL>{typeDescCz}</LABEL><VALUE>{label}</VALUE></ITEM>',
    },
    parcely: {
        id: 'search.parcely.item.content.html',
        defaultMessage: '{label}',
    },
    coords: {
        id: 'search.coords.item.content.html',
        defaultMessage: '<ITEM><LABEL>S-JTSK</LABEL><VALUE>{x5513}, {y5513}</VALUE></ITEM><ITEM><LABEL>WGS84</LABEL><VALUE>{lat}, {lon}</VALUE></ITEM>',
    },
});
//# sourceMappingURL=messages.js.map